import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MDICONS from '@material-ui/icons';
import { includeIntoCompanyAccept } from '../../../store/actions/companyActions';

class CompanyAcceptRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            reassignIdCheck: true,
            accessLevelRadio: 1,
        }
    }

    handleReassignmentToggle = (e) => {
        this.setState({
            [e.target.id]: !this.state.reassignIdCheck
        })
    }

    handleAccessToggle = (accessLevelRadio) => {
        this.setState({
            accessLevelRadio,
        })
    }

    handleSubmit = () => {
        const { reassignIdCheck, accessLevelRadio } = this.state;
        const { notificationItem, companyData } = this.props;
        const { requestMaker } = notificationItem;
        // console.log(reassignIdCheck, accessLevelRadio);
        // console.log(requestMaker, companyData, accessLevelRadio, reassignIdCheck);
        this.props.includeIntoCompanyAccept(requestMaker, companyData, accessLevelRadio, reassignIdCheck);
    }

    render() {
        const labelStyling = {
            marginLeft: "10px",
        }

        const { notifUtils, notificationItem, modalStyles,
            modalTitleStyle, formLabelStyle, modalWidth,
            companyData, alu,
        } = this.props;

        const { accessLevelRadio, reassignIdCheck } = this.state;

        const { notificationIcon } = notifUtils;
        const { notify, requestCode, timestamp, requestMaker } = notificationItem;
        const momentFromNow = moment(timestamp.toDate()).fromNow();
        const notifIcon = notificationIcon[requestCode];

        const { name, coid, uid } = requestMaker;
        const { allMembers } = companyData;
        const listedCompany = coid === "-1" ? "No listed company" : "A company is listed!";
        const isReassignId = uid in (allMembers ?? {});

        const selectedLevelText = alu.textLC[accessLevelRadio];

        return (
            <div className="dynamicModalContainerSm">
                <div className="dynamicModalSm">
                    <h5 style={modalTitleStyle}>Company acceptance request:</h5>
                    <br />
                    <p><span style={{ color: "gray" }}>{notifIcon} <MDICONS.MoreVert /> </span>{notify}<span className="float-right" style={{ color: "gray", fontStyle: "italic" }}><MDICONS.Remove /> {momentFromNow}</span></p>
                    <br />

                    <h5 style={modalTitleStyle}>Requester info:</h5>
                    <br />
                    <ul>
                        <span><b>Name:</b> {name}</span>
                        <br />
                        <span><b>Current company:</b> {listedCompany}</span>
                    </ul>
                    <br />

                    <h5 style={modalTitleStyle}>Grant access:</h5>
                    <br />
                    <form onSubmit={this.handleSubmit}>
                        <ul>
                            {/* REASSIGN EMPLOYEE ID */}
                            {isReassignId ?
                                <div className="form-group">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="reassignIdCheck" checked={reassignIdCheck} onChange={this.handleReassignmentToggle} />
                                        <label style={labelStyling} className="form-check-label" htmlFor="checkbox">Reassign previous employee id?</label>
                                    </div>
                                </div>
                                : <React.Fragment />
                            }

                            {/* RADIO SELECTOR FOR ACCESS LEVEL */}
                            <div className="form-group">
                                <span><b>Select access level:</b></span>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="accessRadios" id="employeeRadio" value="option1" checked={accessLevelRadio === alu.employee} onChange={() => { this.handleAccessToggle(alu.employee) }} />
                                    <label style={labelStyling} className="form-check-label" htmlFor="employeeRadio">Employee</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="accessRadios" id="adminRadio" value="option2" checked={accessLevelRadio === alu.admin} onChange={() => { this.handleAccessToggle(alu.admin) }} />
                                    <label style={labelStyling} className="form-check-label" htmlFor="adminRadio">Admin</label>
                                </div>
                            </div>
                        </ul>
                        <br />
                        <div className="btn btn-danger btn-sm float-right" onClick={this.handleSubmit}>I willingly accept this request and give {selectedLevelText} access</div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        notifUtils: state.notifUtils,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        companyData: state.firestore.data.Company,
        alu: state.alu,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        includeIntoCompanyAccept: (userModelJson, companyModelJson, selectedLevel, isReassignId) => dispatch(includeIntoCompanyAccept(userModelJson, companyModelJson, selectedLevel, isReassignId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAcceptRequest);